export const ROLES = [
    {
      label: "Individual",
      options: [
        {
          label: "Individual Investor",
          value: "individual-investor",
        },
        {
          label: "Individual Developer",
          value: "individual-developer",
        },
        {
          label: "Academics",
          value: "academics",
        },
      ],
    },
    {
      label: "Commercial",
      options: [
        {
          label: "Company",
          value: "company",
        },
        {
          label: "Non-Profit Organization",
          value: "non-profit-organization",
        },
        {
          label: "Educational Institution",
          value: "educational-institution",
        },
      ],
    },
  ];